<div class="odx-bar-parent h-100" odxLayout="flex">
  <app-configuration-wizard-back-button #backButton [project]="project" [floorplanGroup]="FloorplanMenuType.MONITORING_DISPLAY">
  </app-configuration-wizard-back-button>
  <odx-wizard #configurationWizard [vertical]="true" (activeStepChanged)="setActiveStep($event)">
    <odx-wizard-step i18n="@@displayConfiguration.wizard.step1">Display</odx-wizard-step>
    <odx-wizard-step i18n="@@displayConfiguration.wizard.step2" [class.odx-wizard-step--visible]="accessoriesAvailable"
      >Accessories</odx-wizard-step
    >
    <odx-wizard-step i18n="@@displayConfiguration.wizard.step3">Summary</odx-wizard-step>
  </odx-wizard>

  @if (displayFamily && displayStep) {
    <app-option-selector
      class="w-100"
      [hidden]="activeStep !== 0"
      [selectedFamily]="displayFamily"
      [step]="displayStep"
      [originalOptions]="originalConfiguration ? [originalConfiguration.display] : undefined"
      [title]="DisplaySelectorTitleKeyMap[DisplaySelectorType.DISPLAY]"
      [category]="MonitoringCategory.DISPLAYS"
      (optionsSelect$)="setSelectedDisplay($event)"
      (formReady)="selectedDisplayForm = $event"
    ></app-option-selector>
  }

  @if (selectedDisplay && family) {
    <app-option-selector
      class="w-100"
      [hidden]="activeStep !== 1"
      [selectedFamily]="family"
      [originalOptions]="originalConfiguration?.accessories"
      [title]="DisplaySelectorTitleKeyMap[DisplaySelectorType.ACCESSORIES]"
      [step]="family.steps[1]"
      [category]="MonitoringCategory.DISPLAYS"
      [hasQuantities]="true"
      (optionsSelect$)="setSelectedAccessories($event)"
    >
    </app-option-selector>
  }

  @if (activeStep === 2) {
    <app-monitoring-overview
      [title]="DisplaySelectorTitleKeyMap[DisplaySelectorType.OVERVIEW]"
      [sections]="groupedSections"
      [showCategory]="true"
    ></app-monitoring-overview>
  }

  <app-product-config-stepper-bar
    (dismiss)="backButton.navigateBack()"
    (next)="onSubmit()"
    (previous)="onPrevious()"
    [activeStep]="!accessoriesAvailable && activeStep >= 2 ? activeStep - 1 : activeStep"
    [steps]="accessoriesAvailable ? steps + 1 : steps"
  >
  </app-product-config-stepper-bar>
</div>
